<template>
  <div class="ticket_info_way">
    <div class="ticket_info_way_title ticket_icon">
      <img :src="staticAssets.ImgObj.ticket_icon" alt />
      <span>{{TLang('取票方式','my')}}</span>
    </div>

    <div
      class="ticket_info_way_img card_img"
      v-if="
        data_source.defIssueTicketType == 4 && data_source.defDeliveryType == 1
      "
    >
      <div class="ticket_img_show" :style="card_style">
        <img
          :src="staticAssets.ImgObj.card_icon2"
          alt
          style="width: 26px;margin: 0px 5px 0 16px;"
        />
        <span class="ticket_img_show_text">{{TLang('身份证电子票','my')}}</span>
      </div>
    </div>

    <div
      class="ticket_info_way_img ticket_img"
      v-if="
        data_source.defIssueTicketType != 1 &&
          data_source.defIssueTicketType != 4 &&
          data_source.defDeliveryType != 3 && 
          data_source.defDeliveryType != 5
      "
    >
      <div class="ticket_img_show" :style="ticket_style">
        <img
          :src="staticAssets.ImgObj.ticket_icon2"
          alt
          style="width: 25px;margin: 0px 6px 0 18px;"
        />
        <span class="ticket_img_show_text">{{TLang('电子票','my')}}</span>
      </div>
    </div>
    <div
      class="ticket_info_way_img card_img"
      v-if="
        data_source.defDeliveryType != null &&
          data_source.defDeliveryType != 3 &&
          data_source.defDeliveryType != 1 &&
          data_source.defDeliveryType != 5
      "
    >
      <div class="ticket_img_show" :style="paper_ticket_style">
        <img
          :src="
            kuaidi_flag
              ? staticAssets.ImgObj.kuaidi_icon
              : staticAssets.ImgObj.ziqu_icon
          "
          alt
          style="width: 26px;margin: 0px 11px 0 24px;"
        />
        <span class="ticket_img_show_text">
          {{ kuaidi_flag ? TLang('快递配送','my') : TLang('上门自取','my') }}
        </span>
      </div>
    </div>
    <div
      class="ticket_info_way_img card_img"
      v-if="data_source.defDeliveryType === 5"
    >
      <div class="ticket_img_show" :style="paper_ticket_style">
        <img
          :src="
            kuaidi_flag
              ? staticAssets.ImgObj.kuaidi_icon
              : staticAssets.ImgObj.ziqu_icon
          "
          alt
          style="width: 26px;margin: 0px 11px 0 24px;"
        />
        <span class="ticket_img_show_text">
          {{ TLang('临场派票','my') }}
        </span>
      </div>
    </div>
    <div
      class="ticket_info_way_img card_img"
      v-if="
        data_source.defDeliveryType != null && data_source.defDeliveryType == 3
      "
    >
      <div class="ticket_img_show" :style="machine_ticket_style">
        <img
          :src="staticAssets.ImgObj.machine_icon"
          alt
          style="width: 22px;margin: 4px 12px 0 17px;"
        />
        <span :class="!CheckCN() ? 'ticket_img_show_text text-One':'ticket_img_show_text'">{{TLang('自助机取票','my')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from "@/utils";
export default {
  name: "TicketType",
  data() {
    return {
      ticket_style:
        "width:114px;background:url(" +
        require("../../assets/imgs/ticket_icon_back.png") +
        ") no-repeat;",
      card_style:
        "width:146px;background:url(" +
        require("../../assets/imgs/card_icon_back.png") +
        ") no-repeat;",
      paper_ticket_style:
        "width:138px;background:url(" +
        require("../../assets/imgs/paper_icon_back.png") +
        ") no-repeat;",
      machine_ticket_style:
        "width:138px;background:url(" +
        require("../../assets/imgs/machine_icon_back.png") +
        ") no-repeat;",
      data_source: this.table_source,
      kuaidi_flag: this.kuaidi_type,
      CookiesOne: getCookie('df_lang'),
    };
  },
  props: ["table_source", "kuaidi_type"],
  watch: {
    table_source: {
      handler: function(newVal) {
        this.data_source = newVal;
      },
      deep: true,
      immediate: true
    },
    kuaidi_type(val) {
      this.kuaidi_flag = val;
    }
  },
  components: {},
  beforeCreate() {},
  created() {},
  destroyed() {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="less">
.ticket_info_way {
  .ticket_info_way_title {
    display: flex;
    align-items: center;
  }
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ticket_icon span {
  .drama_font_style(inherit, 500, 16px, 21px);
  display: inline-block;
  margin-left: 15px;
  color: rgba(17, 17, 17, 1);
  height: 21px;
}
.ticket_icon i {
  .drama_font_style(normal, 500, 12px, 16px);
  margin-left: 4px;
  color: rgba(102, 102, 102, 1);
}
.ticket_info_way_img {
  height: 40px;
  margin: 16px 0 24px 32px;
  .ticket_img_show {
    line-height: 14px;
    height: 100% !important;
    align-items: center;
    background-size: 100% 100% !important;
    display: flex;
    .ticket_img_show_text {
      font-size: 14px;
      font-weight: 600;
      color: rgba(61, 150, 226, 1);
    }
  }
}
.card_img {
  width: 146px;
}
.ticket_img {
  width: 114px;
}
.text-One{
    font-size: 6px!important;
    line-height: 15px!important;
}
</style>
